<script setup>
const props = defineProps(["related_products", "parent_collection"]);

import { onMounted, ref } from "vue";
import Product from "@/components/cards/Product.vue";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { prefersReducedMotion } from "@/utils/prefersReducedMotion";

const heading = ref(null);

onMounted(() => {
	if (prefersReducedMotion()) return;

	gsap.registerPlugin(ScrollTrigger);

	gsap.from(heading.value, {
		y: 24,
		opacity: 0,
		duration: 0.8,
		ease: "power2.inOut",
		scrollTrigger: {
			trigger: heading.value,
			start: "top 90%",
			end: "bottom 20%",
		},
	});
});
</script>

<template>
	<section class="py-64 lg:py-120">
		<div class="container">
			<div
				class="mb-20 flex items-end justify-between lg:mb-40"
				ref="heading"
			>
				<h2 class="h4 font-primary-condensed">Similar Products</h2>
				<router-link
					:to="{
						name: 'collection',
						params: { slug: parent_collection.slug },
					}"
					class="h8 font-primary-condensed opacity-50 transition-opacity hover:opacity-100"
				>
					<span>See all products</span>
				</router-link>
			</div>
			<div class="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
				<Product
					v-for="product in related_products"
					:key="product.id"
					:product="product"
				/>
			</div>
		</div>
	</section>
</template>
